export const buildGooglePlaceDetailsRequest = (
  placeId: string,
  sessionToken?: google.maps.places.AutocompleteSessionToken,
  fields = ['address_component', 'formatted_address', 'geometry'],
) => ({
  placeId,
  sessionToken,
  fields,
})
